import Odometer from "../../../node_modules/odometer/odometer";

function triggerOnScroll() {
    var pageBody = document.querySelector(".page__container");
    if (pageBody) {
        window.addEventListener("scroll", function() {
            var pageBottom = pageBody.getBoundingClientRect().bottom;
            if (document.body.scrollTop || document.documentElement.scrollTop > pageBottom) {
                numberTicker();
            }
        });
    }
}

function numberTicker() {
    var el = document.querySelectorAll(".infoNumbers__stats");
    el.forEach(function(el) {
        new Odometer({
            el: el,
            value: 999,
            format: "(,ddd)",
            theme: "default",
            auto: false,
            duration: 4000
        });
        el.innerHTML = el.getAttribute("data-info");
    });
}

function init() {
    triggerOnScroll();
}

export default { init };
